import { authHeaders, handleUnauthorized } from './http';
const BASE = '/api/phase10';

async function p10Request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(init?.headers || {}) },
    ...init,
  });
  handleUnauthorized(res);
  if (!res.ok) throw new Error(await res.text() || res.statusText);
  return res.json();
}

export const phase10Api = {
  equilibrium: (scenario?: string) => p10Request<EquilibriumData>(`/equilibrium${scenario ? `?scenario=${encodeURIComponent(scenario)}` : ''}`),
  constraints: () => p10Request<any[]>('/constraints'),
  literature: () => p10Request<any[]>('/literature'),
  perceptionSummary: () => p10Request<any[]>('/perception/summary'),
  perceptionSources: () => p10Request<any[]>('/perception/sources'),
  perceptionPosts: (params?: { variable_id?: string; platform?: string }) => {
    const q = new URLSearchParams();
    if (params?.variable_id) q.set('variable_id', params.variable_id);
    if (params?.platform) q.set('platform', params.platform);
    const qs = q.toString();
    return p10Request<any[]>(`/perception/posts${qs ? `?${qs}` : ''}`);
  },
  aggregatePerception: () => p10Request<{ updated: number }>('/perception/aggregate', { method: 'POST' }),
  ingestMockPost: (body: { platform: string; variable_id: string; content: string; sentiment: number; reaction_count?: number }) =>
    p10Request<{ status: string }>('/perception/ingest-mock', { method: 'POST', body: JSON.stringify(body) }),
};

export interface EquilibriumData {
  scenario_id: string;
  blocks: {
    block_id: string;
    block_name: string;
    output_variable_id: string;
    value: number;
    trace: { label: string; value: number; note?: string }[];
  }[];
  unconstrained_gdp_growth: number;
  equilibrium_gdp_growth: number;
  binding_constraints: string[];
}
